import React from "react";
import Table from "../../../common/components/Table/Table";
import ContentCard from "../../../common/components/ContentCard/ContentCard";
import _ from "lodash";
import MARVEL from "../../../common/utils/MarvelUrls";
import { Label } from 'semantic-ui-react'

export default class TenantSidebarV2 extends React.Component {

    get tenantTable() {
        const {tenants} = this.props;

        const typeColorMap = new Map([
            ["PRODUCTION", "green"],
            ["TEST", "orange"],
            ["POC", "blue"],
            ["INTERNAL", "grey"],
        ]);

        return (
            <ContentCard
                headerContent={"Tenants"}
            >
                {_.isEmpty(tenants) ?
                    <h3 style={{padding: "12px 20px 20px"}}>No Associated Tenants</h3>
                    : <Table className="tenant-list-table">
                        {tenants.map((t, key) => (
                            <tr key={key}>
                                <td>
                                    <a
                                        target="_blank" rel="noopener noreferrer"
                                        href={MARVEL.CONFIG_TOOL.routeToTenantDetail + t.tenantid}>
                                        {t.name}</a>
                                    <Label color={typeColorMap.get(t.type)} size={"mini"} horizontal>
                                        {t.type}
                                    </Label>
                                </td>
                            </tr>
                        ))}
                    </Table>
                }
            </ContentCard>
        )
    }

    render() {
        return (
            <div className={"tenant-list-sidebar"}>
                {this.tenantTable}
            </div>
        )
    }
}
